export default __webpack_public_path__ + "static/media/mailSent.9fb090f6.svg";